import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { lookupName } from './utils.js';

var defaultOptions = {
  cache: true,
  transform: function transform(data) {
    return data;
  }
};
var lookups = {};

var getLookupAction = function getLookupAction(name) {
  return lookups[name].config.action;
};

var getLookupOptions = function getLookupOptions(name) {
  return lookups[name].config.options;
};
/**
 * Determines whether a lookup has been registered
 * @param {string} name The name of a lookup to check
 * @returns {boolean} True if the lookup has been registered, otherwise false
 */


var lookupExists = function lookupExists(name) {
  return lookups.hasOwnProperty(name);
};
/**
 * Finds a previously registered lookup if it exists
 * @param {string} name The name of a lookup to check
 * @returns {object|null} The registered lookup, or null if it does not exist
 */


var findLookup = function findLookup(name) {
  if (lookupExists(name)) {
    return lookups[name];
  }

  return null;
};
/**
 * Registers a new lookup
 * @param {string} name Name of the lookup to register
 * @param {function} action API action creator for requesting lookup data, receives lookup parameters
 * @param {object} options Default options for requesting lookup data
 * @param {boolean} options.cache Whether lookup requests should save and retrieve their data from cached state, default true
 * @param {number} options.cacheExpiry Time in milliseconds that cached data should be kept before being invalidated, or null for indefinite, default null
 * @param {number} options.cacheLimit Number of copies of cached data for different request parameters that should be kept, or null for unlimited, default null
 * @param {function} options.transform Transform function to apply when lookup data is retrieved successfully, receives the original data and lookup parameters, and returns the transformed data
 * @returns {object} The registered lookup
 * @returns {string} `name` The registered name of the lookup
 * @returns {number} `registeredAt` Timestamp when the lookup was registered
 * @returns {object} `config` The configuration of the lookup when it was registered
 * @returns {function} `unregister` A function to unregister this lookup
 * @returns {number} `unregisteredAt` If unregistered, the timestamp when this occurred
 */


var registerLookup = function registerLookup(name, action) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (lookupExists(name)) {
    console.warn("Lookup has already been registered: ".concat(name));
  }

  var config = {
    action: action,
    options: _objectSpread2(_objectSpread2({}, defaultOptions), options)
  };
  var lookup = {
    name: name,
    registeredAt: Date.now(),
    config: config,
    unregister: function unregister() {
      return unregisterLookup(name);
    }
  };
  lookups[name] = lookup;
  return lookup;
};
/**
 * Unregisters an existing lookup
 * @param {string|object} lookup A previously registered lookup or its name
 */


var unregisterLookup = function unregisterLookup(lookup) {
  var name = lookupName(lookup);
  var found = findLookup(name);

  if (found) {
    found.unregistedAt = Date.now();
    delete lookups[name];
  }
};

export { findLookup, getLookupAction, getLookupOptions, lookupExists, registerLookup, unregisterLookup };
